<template>
  <div>
    <b-sidebar
      id="sidebar-product"
      v-model="showSlide"
      backdrop
      shadow
      backdrop-variant="dark"
      right
      aria-labelledby="sidebar-product-title"
      @hidden="hide()"
      no-header
    >
      <template>
        <div v-if="isLoading">
          <OtherLoading />
        </div>
        <div class="py-3" v-else>
          <label class="ml-2">ข้อมูลลูกค้า</label>
          <div class="mt-3 p-2">
            <div class="mx-2 d-flex">
              <b-input-group class="panel-input-border">
                <b-form-input
                  id="product-search"
                  class="input-serach rounded-circle"
                  placeholder="ค้นหา"
                  @keypress="handlePushMessage"
                  v-model="filter.search"
                ></b-form-input>
              </b-input-group>
              <b-button
                class="search-circle-bth"
                :style="$store.state.backgroundSecondary"
                ><span class="icon-input m-auto pr-2 text-white">
                  <font-awesome-icon
                    icon="search"
                    title="View"
                    @click="searchUser('search')"
                  /> </span
              ></b-button>
            </div>
          </div>
          <div class="mt-3 py-2 detail-panel">
            <div class="px-2 text-sub text-grey d-flex justify-content-between">
              <span>ชื่อ / สมาชิก / โทร</span>
              <span>ระดับ / คะแนนสะสม / วันที่สมัคร</span>
            </div>
            <div
              class="m-2 py-2 px-2 customer-card"
              v-for="(c, index) in customerList"
              :key="index"
              @click="selectCustomer(c)"
            >
              <div class="d-flex justify-content-between">
                <p>
                  <label>{{ c.first_name_th }} {{ c.last_name_th }}</label>
                </p>
                <p>{{ c.member_tier }}</p>
              </div>
              <div class="d-flex justify-content-between">
                <p>{{ c.member_id }}</p>
                <p>{{ c.point }} คะแนน</p>
              </div>
              <div class="d-flex justify-content-between">
                <p>{{ c.telephone }}</p>
                <p>{{ new Date(c.created_time) | moment($formatDate) }}</p>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template #footer>
        <div class="text-center">
          <b-pagination
            v-model="filter.page"
            :total-rows="rows"
            :per-page="5"
            class="m-md-0 page-item"
            @change="pagination"
            align="center"
          ></b-pagination>
        </div>
      </template>
    </b-sidebar>
    <ModalLoading ref="modalLoading" :hasClose="false" />
  </div>
</template>

<script>
import OtherLoading from "@/components/loading/OtherLoading";
import InputText from "@/components/inputs/InputText";
import ModalLoading from "@/components/modal/alert/ModalLoading";
export default {
  name: "SlideCustomerList",
  components: { OtherLoading, InputText, ModalLoading },
  props: {
    search: {
      type: String,
      isRequired: true,
    },
  },
  data() {
    return {
      showSlide: false,
      filter: {
        search: "",
        page: 1,
      },
      rows: 0,
      customerSelect: "",
      customerList: [],
      isLoading: false,
    };
  },
  //   watch: {
  //   },
  methods: {
    async show() {
      this.filter.search = this.search;
      this.showSlide = true;
      this.isLoading = true;
      await this.searchUser("search");
      this.isLoading = false;
    },
    hide() {
      this.showSlide = false;
      this.filter.page = 1;
    },
    searchUser(type) {
      this.$refs.modalLoading.show();
      this.filter.page = type == "search" ? 1 : this.filter.page;
      this.customerList = [];
      let body = {
        search: this.filter.search,
        datetime: this.$moment()
          .add("years", 543)
          .format("DD/MM/YYYY HH:mm:ss"),
        skip: (this.filter.page - 1) * 5,
        take: 5,
        branch_id: this.$cookies.get("branch_id"),
      };

      this.axios
        .post(`${this.$baseUrl}/customer/searchuser`, body)
        .then((data) => {
          if (data.result == 1) {
            this.customerList = data.detail;
            this.rows = data.total_count;
          }
          this.$refs.modalLoading.hide();
        });
    },
    handlePushMessage(e) {
      if (e.keyCode === 13 && !e.shiftKey) {
        e.preventDefault();
        this.searchUser("search");
      }
    },
    pagination(Page) {
      this.filter.page = Page;
      this.searchUser("pagination");
    },
    async selectCustomer(customer) {
      this.$emit("onChangehUser", customer.member_id, "search");
      this.hide();
    },
  },
};
</script>

<style lang="scss" scoped>
.customer-card {
  background-color: white;
  border-radius: 8px;
  p {
    padding: 0px;
  }
}
.customer-card:hover {
  background-color: #d1d1d1;
}
</style>
